import { createPathToRegexpParser } from '@folklore/routes';
import { HydrationBoundary, QueryClientProvider } from '@tanstack/react-query';
import { hydrateRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Router } from 'wouter';

import Api from './lib/api/Api';
import defaultRichTextElements from './lib/defaultRichTextElements';

// import installAds from './ads';
import App from './components/App';
import { ApiContextProvider } from './contexts/ApiContext';
import { RequestContextProvider } from './contexts/RequestContext';
import { SiteContextProvider } from './contexts/SiteContext';
import createQueryClient from './queryClient';

// import { prefetchAuthUser } from './hooks/useAuth';

const queryClient = createQueryClient();

const pathToRegexpParser = createPathToRegexpParser();

// const embeddedStyles = window.__ENTRYPOINTS_CSS || null;
const embeddedStylesElements = [...document.getElementsByTagName('style')].filter(
    (it) => it.id.match(/^embedded-styles/) !== null,
);
const embeddedStyles =
    embeddedStylesElements.length > 0 ? embeddedStylesElements.map((it) => it.innerText) : null;
const embeddedScriptsElement = document.getElementById('embedded-scripts') || null;
const embeddedScripts = embeddedScriptsElement !== null ? embeddedScriptsElement.innerText : null;
const presentation = window.__PRESENTATION || null;
const site = window.__SITE || null;
const siteHandle = window.__SITE_HANDLE || 'urbania';
const translations = window.__TRANSLATIONS;
const ssrPath = window.__SSR_PATH;
const assetsManifest = window.__ASSETS_MANIFEST;
const isBot = window.__IS_BOT || false;
const isRedirector = window.__IS_REDIRECTOR || false;
const facebookAppId = window.__FACEBOOK_APP_ID || '1051760225433251';
const dehydratedState = window.__QUERY_STATE || null;
const googleClientId =
    window.__GOOGLE_CLIENT_ID ||
    '432379609774-r4t5037c96fnp2ja3te6dq9i74dke3uq.apps.googleusercontent.com';
const locale = window.__LOCALE || 'fr-CA';
const apiBaseUrl = window.__API_BASE_URL || 'https://api.urbania.ca';
const authBaseUrl = window.__AUTH_BASE_URL || `${apiBaseUrl.replace(/\/$/, '')}/auth`;

const api = new Api({
    isBot,
    baseUrl: apiBaseUrl,
    authBaseUrl,
});

// prefetchAuthUser(queryClient, api);

hydrateRoot(
    document,
    <Router parser={pathToRegexpParser} ssrPath={ssrPath}>
        <QueryClientProvider client={queryClient}>
            <HydrationBoundary state={dehydratedState}>
                <IntlProvider
                    locale={locale}
                    defaultLocale="fr-CA"
                    messages={translations}
                    defaultRichTextElements={defaultRichTextElements}
                >
                    <RequestContextProvider
                        host={window.location.host}
                        protocol={window.location.protocol}
                    >
                        <ApiContextProvider client={api}>
                            <SiteContextProvider
                                site={site}
                                handle={siteHandle}
                                isRedirector={isRedirector}
                            >
                                <App
                                    isBot={isBot}
                                    presentation={presentation}
                                    isRedirector={isRedirector}
                                    facebookAppId={facebookAppId}
                                    googleClientId={googleClientId}
                                    assetsManifest={assetsManifest}
                                    embeddedStyles={embeddedStyles}
                                    embeddedScripts={embeddedScripts}
                                    withHtml
                                />
                            </SiteContextProvider>
                        </ApiContextProvider>
                    </RequestContextProvider>
                </IntlProvider>
            </HydrationBoundary>
        </QueryClientProvider>
    </Router>,
    {
        onRecoverableError: (error, { componentStack }) =>
            console.log('HYDRATE', (error as Error).message, componentStack),
    },
);
